import tw from 'tailwind-styled-components'
import {bgMixin} from '@components/main-menu/mixins'
import {cn} from '@containers/html-utils'

export const TwItem = tw.div<{$selected?: boolean}>`
  relative
  isolate
  flex
  items-center
  gap-8
  px-12
  min-h-[30px]
  max-h-[30px]

  text-12
  leading-4
  rounded-4

  cursor-pointer

  ${p =>
    cn(
      p.$selected ? 'text-panel-text-primary' : 'text-panel-text-secondary',
      bgMixin(p.$selected)
    )}
`

type TwMsgCountType = {
  $hasNewMsg: boolean
}

export const TwMsgCount = tw.div<TwMsgCountType>`
  text-11
  leading-16
  whitespace-nowrap

  ${p =>
    p.$hasNewMsg ? '!text-notification-primary' : '!text-panel-text-secondary'}
`

export const TwChatItemText = tw.span`
  truncate max-w-[140px]
`

export const TwMentionSymbol = tw.span`
  text-notification-primary
`
